<template>
    <div>
        <b-row v-if="permissions.includes('payroll-inquiry')">
            <!-- card collapsible  -->
            <b-col md="12">
                <b-card-actions
                title="Filter"
                :collapsed="true"
                action-collapse
                >
                    <b-row>
                        <b-col md="3">
                            <b-form-group
                            label="Name"
                            label-for="name"
                            >
                                <b-form-input
                                id="name"
                                placeholder="Name"
                                v-model="filter.name"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Month"
                            label-for="select_month"
                            >
                                <b-form-select
                                id="select_month"
                                v-model="filter.selectedMonth"
                                :options="filter.optionsMonth"
                                />
                                <!-- Selected: <strong>{{ filter.selectedMonth }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Year"
                            label-for="year"
                            >
                                <b-form-input
                                id="year"
                                placeholder="Year"
                                v-model="filter.year"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Has Paid"
                            label-for="select_haspaid"
                            >
                                <b-form-select
                                id="select_haspaid"
                                v-model="filter.selectedHasPaid"
                                :options="filter.optionsHasPaid"
                                />
                                <!-- Selected: <strong>{{ filter.selectedHasPaid }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mt-1"
                            @click="getInquiry(1, filter.name, filter.selectedMonth, filter.year, filter.selectedHasPaid)"
                            >
                            Search
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-actions>
            </b-col>
        </b-row>
        <b-row v-if="permissions.includes('payroll-create')">
            <b-col class="text-right mb-1">
                <router-link to="/hr/payrolls/add">
                    <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    pill
                    class="px-3 ml-1"
                    >
                    Add Payroll
                    </b-button>
                </router-link>
            </b-col>
        </b-row>
        <b-card v-if="permissions.includes('payroll-inquiry')">
            <!-- search input -->
            <b-row>
                <b-col class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <b-form-input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block"
                            />
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- table -->
            <vue-good-table
            :columns="columns"
            :rows="rows"
            :rtl="direction"
            :search-options="{
                enabled: true,
                externalQuery: searchTerm 
            }"
            :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
            :pagination-options="{
                enabled: true,
                perPage:pageLength
            }"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >

                    <!-- Column: Name -->
                    <span
                    v-if="props.column.field === 'name'"
                    class="text-nowrap"
                    >
                        <!-- <b-avatar
                            :src="props.row.avatar"
                            class="mx-1"
                        /> -->
                        <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Has Month -->
                    <span
                    v-else-if="props.column.field === 'monthyear'"
                    class="text-nowrap"
                    >
                        <!-- <b-avatar
                            :src="props.row.avatar"
                            class="mx-1"
                        /> -->
                        <span class="text-nowrap" v-if="props.row.month === 1">January {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 2">February {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 3">March {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 4">April {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 5">May {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 6">June {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 7">July {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 8">August {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 9">September {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 10">October {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 11">November {{ props.row.year }}</span>
                        <span class="text-nowrap" v-else-if="props.row.month === 12">December {{ props.row.year }}</span>
                    </span>

                    <!-- Column: Has Paid -->
                    <span
                    v-else-if="props.column.field === 'has_paid'"
                    class="text-nowrap"
                    >
                        <!-- <b-avatar
                            :src="props.row.avatar"
                            class="mx-1"
                        /> -->
                        <span class="text-nowrap" v-if="props.row.has_paid === 1">Paid</span>
                        <span class="text-nowrap" v-else-if="props.row.has_paid === 0">Unpaid</span>
                    </span>

                    <!-- Column: Type -->
                    <span v-else-if="props.column.field === 'type'">
                        <b-badge :variant="statusVariant(props.row.type)">
                            <span v-if="props.row.type === 1">Monthly</span>
                            <span v-else-if="props.row.type === 2">Once</span>
                        </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                        <span>
                            <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            >
                                <template v-slot:button-content>
                                    <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="text-body align-middle mr-25"
                                    />
                                </template>
                                <b-dropdown-item v-bind:to="{path: '/hr/payrolls/' +props.row.id}" v-if="permissions.includes('payroll-detail')">
                                    <feather-icon
                                    icon="Edit2Icon"
                                    class="mr-50"
                                    />
                                    <span>Detail</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="paidPayroll(props.row.id)" v-if="permissions.includes('payroll-update') && props.row.has_paid === 0">
                                    <feather-icon
                                    icon="CheckCircleIcon"
                                    class="mr-50"
                                    />
                                    <span>Paid</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="deletePayroll(props.row.id)" v-if="permissions.includes('payroll-delete')">
                                    <feather-icon
                                    icon="TrashIcon"
                                    class="mr-50"
                                    />
                                    <span>Delete</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>

                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap ">
                            Showing {{ meta.from }} to {{ meta.to }}
                            </span>
                            <span class="text-nowrap">&nbsp;of {{ meta.total }} entries </span>
                        </div>
                        <div>
                            <b-pagination
                            :value="1"
                            :total-rows="meta.total"
                            :per-page="meta.per_page"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mt-1 mb-0"
                            @input="(value)=>getInquiry(value, filter.name, filter.selectedMonth, filter.year, filter.selectedHasPaid)"
                            >
                            <template #prev-text>
                                <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                                />
                            </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-card>
    </div>
</template>

<script>
import {
    BForm, BFormFile, BModal, BButton, BRow, BCol, BCard, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'

export default {
    components: {
        BCardActions,
        VueGoodTable,
        ToastificationContent,
        ValidationProvider,
        ValidationObserver,
        BForm,
        BFormFile,
        BModal,
        BButton,
        BRow,
        BCol,
        BCard, 
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                },
                {
                    label: 'Name',
                    field: 'name',
                },
                {
                    label: 'Month - Year',
                    field: 'monthyear',
                },
                {
                    label: 'Has Paid',
                    field: 'has_paid',
                },
                {
                    label: 'Type',
                    field: 'type',
                },
                {
                    label: 'Action',
                    field: 'action',
                    width: '100px'
                },
            ],
            filter: {
                name: '',
                selectedMonth: '',
                optionsMonth: [
                    { value: '', text: 'All' },
                    { value: 1, text: 'January' },
                    { value: 2, text: 'February' },
                    { value: 3, text: 'March' },
                    { value: 4, text: 'April' },
                    { value: 5, text: 'May' },
                    { value: 6, text: 'June' },
                    { value: 7, text: 'July' },
                    { value: 8, text: 'August' },
                    { value: 9, text: 'September' },
                    { value: 10, text: 'October' },
                    { value: 11, text: 'November' },
                    { value: 12, text: 'December' }
                ],
                year: '',
                selectedHasPaid: '',
                optionsHasPaid: [
                    { value: '', text: 'All' },
                    { value: 0, text: 'Unpaid' },
                    { value: 1, text: 'Paid' }
                ],
            },
            meta: {
                current_page: 1,
                last_page: 0,
                from: 0,
                to: 0,
                per_page: 10,
                total: 0,
            },
            permissions: [],
            rows: [],
            searchTerm: '',
            errors: '',
            errMessage: ''
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-primary',
                2 : 'light-success'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        this.getAllPermissions()
        this.getInquiry(1, '', '', '', '')
    },
    methods: {
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getInquiry($page, $name, $month, $year, $paid) {
            this.$http.get('payrolls?page=' + $page + ($name ? "&name="+this.filter.name : '') + ($month ? "&month="+this.filter.selectedMonth : '') + ($year ? "&year="+this.filter.year : '') + ($paid ? "&has_paid="+this.filter.selectedHasPaid : ''))
            .then(res => { 
                this.rows = res.data.data
                // console.log(res.data.data)
                var meta = res.data.meta
                if (meta.from != null) {
                    this.meta.from = meta.from
                }
                if (meta.to != null) {
                    this.meta.to = meta.to
                }
                this.meta.current_page = meta.current_page
                this.meta.last_page = meta.last_page
                this.meta.per_page = meta.per_page
                this.meta.total = meta.total
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            })
        },
        deletePayroll($id) {
            this.$http
            .post("payroll/"+$id+"/delete")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Payrolls has been Deleted',
                        variant: 'danger',
                    },
                })
                location.href = "/hr/payrolls"
                console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                console.log(errors.response)
            })
        },
        // filterSearch() {
        //     this.$http
        //     .get("payrolls?"+"name="+this.filter.name+"&"+"month="+this.filter.selectedMonth+"&"+"year="+this.filter.year+"&"+"has_paid="+this.filter.selectedHasPaid)
        //     .then((response) => {
        //         this.rows = response.data.data
        //         // console.log(response.data.data)
        //     }).catch((errors) => {
        //         console.log(errors.response)
        //     })
        // },
        paidPayroll(id) {
            this.$http
            .post("payroll/"+id+"/paid")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Payrolls has been Paid',
                        variant: 'success',
                    },
                })
                location.href = "/hr/payrolls"
                console.log(response.data.data)
            }).catch((errors) => {
                console.log(errors.response)
            })
        },
    },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>